import { useSettings } from "~/store/settings";
import api from "../auth/api";

export default async function fetchTranslations () {
	const store = useSettings();

	await api<{ [x: string]: string }>({
		url: `/cron/locales/synapse/${store.locale}`,
		type: "config",
	}).then((res) => {
		store.translations = res;
	});
};
